module.exports = __webpack_public_path__ + "static/img/HDKG.a20c2f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HDKG.png
// module id = yxyI
// module chunks = 34